import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Container } from '../components/ui';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import CTASection from '../components/CTASection';
import { SegmentCard, FeatureCard } from '../components/cards';
import { SectionHeading } from '../components/ui';
import { SOLUTION_LIST, SERVICES } from '../data/content';

export default function Solutions() {
  const { t } = useLanguage();
  return (
    <div>
      <PageHero
        eyebrow={t('nav.solutions')}
        title={t('home.segments.title')}
        subtitle={t('home.segments.subtitle')}
      />
      <section className="px-5 py-16 sm:px-8 sm:py-20">
        <Container>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {SOLUTION_LIST.map((seg, i) => (<Reveal key={seg.slug} delay={i * 80}><SegmentCard seg={seg} ctaLabel={t('common.explore')} /></Reveal>))}
          </div>
        </Container>
      </section>
      <section className="bg-slate-50 px-5 py-16 dark:bg-white/[0.02] sm:px-8 sm:py-24">
        <Container>
          <Reveal><SectionHeading eyebrow="Every segment" title="What every organisation gets" subtitle="Whatever your model, the platform and managed services flex around how you operate." /></Reveal>
          <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (<Reveal key={s.title} delay={i * 60}><FeatureCard {...s} /></Reveal>))}
          </div>
        </Container>
      </section>
      <CTASection />
    </div>
  );
}
